import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_CONFI_COST_ID_LOADING = 'GET_CONFI_COST_ID_LOADING';
export const GET_CONFI_COST_ID_SUCCESS = 'GET_CONFI_COST_ID_SUCCESS';
export const GET_CONFI_COST_ID_REJECT = 'GET_CONFI_COST_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getConfiCostIdLoading = () => ({ type: GET_CONFI_COST_ID_LOADING });
export const getConfiCostIdSuccess = (payload) => ({ type: GET_CONFI_COST_ID_SUCCESS, payload });
export const getConfiCostIdReject = (payload) => ({ type: GET_CONFI_COST_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getConfiCostIdRequest = async (formData, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { id: formData.id ?? formData },
    }, getState);
    return request(`/Costs/web/GetCostsById`, options);
};